import React from "react";
import { Modal } from "react-bootstrap";
import Slider from "rc-slider";
import CommonButton from "../../components/commonButton";
import withModal from "../../components/withModal";
import { CheckboxOption, multiMessageStyle, MultiValueMessage } from "../../components/form/utils";
import CustomSelect from "../../components/form/CustomSelect";


const MarketPlaceFilterInner = ({
    onClose,
    categories,
    config,
    filterValues,
    setFilterValues,
    fetchStatesOptions,
    fetchCitiesOptions,
    onApply,
    onClear,
}) => {
    const handleApply = () => {
        onApply();
        onClose();
    };

    const handleClear = () => {
        onClear();
        onClose();
    };

    return (
        <>
            <Modal.Body className="gap-4 grid">


                <CustomSelect
                    className="g-col-12"
                    isMulti
                    isClearable
                    isSearchable
                    label={{ name: "Categories" }}
                    options={categories?.map(parent => ({
                        label: parent.name,
                        options: parent.subcategories?.map(sub => ({
                            value: sub.id,
                            label: sub.name
                        })) || []
                    })) || []}
                    value={
                        categories?.flatMap(parent => parent.subcategories || [])
                            .filter(sub => filterValues.category_id.includes(sub.id))
                            .map(sub => ({ value: sub.id, label: sub.name })) || []
                    }
                    onChange={(selected) => setFilterValues({ ...filterValues, category_id: selected ? selected.map(s => s.value) : [] })}
                    placeholder="Search & Select Categories"


                />


                <CustomSelect
                    className="g-col-6"
                    isMulti
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    selectProps={{
                        components: { Option: CheckboxOption, MultiValue: (props) => <MultiValueMessage {...props} message="States Selected" /> },
                        styles: multiMessageStyle
                    }}
                    showSelectAll
                    label={{ name: "States" }}
                    name="state_id"
                    value={filterValues.state_id}
                    onChange={(name, val) => {
                        setFilterValues({ ...filterValues, [name]: val, city_id: [] });
                    }}
                    fetchOptions={fetchStatesOptions}
                    placeholder="Search States"

                />


                <CustomSelect
                    className="g-col-6"
                    isMulti
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    showSelectAll
                    selectProps={{
                        components: { Option: CheckboxOption, MultiValue: (props) => <MultiValueMessage {...props} message="Cities Selected" /> },
                        styles: multiMessageStyle
                    }}
                    label={{ name: "Cities" }}
                    name="city_id"
                    value={filterValues.city_id}
                    onChange={(name, val) => setFilterValues({ ...filterValues, [name]: val })}
                    fetchOptions={fetchCitiesOptions}
                    placeholder="Search Cities"

                />

                <div className="g-col-12">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="mb-0 fw-medium text-dark">Price Range</label>
                        <span className="text-muted small fw-bold">
                            ₹{filterValues.min_price || config.price_bounds.min} - ₹{filterValues.max_price || config.price_bounds.max}
                        </span>
                    </div>
                    <div className="px-2 py-2">
                        <Slider
                            range
                            min={config.price_bounds.min}
                            max={config.price_bounds.max}
                            defaultValue={[filterValues.min_price || config.price_bounds.min, filterValues.max_price || config.price_bounds.max]}
                            value={[filterValues.min_price || config.price_bounds.min, filterValues.max_price || config.price_bounds.max]}
                            onChange={(val) => setFilterValues({ ...filterValues, min_price: val[0], max_price: val[1] })}
                            trackStyle={[{ backgroundColor: '#7C2439' }]}
                            handleStyle={[
                                { borderColor: '#7C2439', backgroundColor: '#fff', opacity: 1, boxShadow: 'none' },
                                { borderColor: '#7C2439', backgroundColor: '#fff', opacity: 1, boxShadow: 'none' }
                            ]}
                            railStyle={{ backgroundColor: '#e9ecef' }}
                        />
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer >
                <CommonButton
                    title="Clear"
                    variant="outline"
                    onClick={handleClear}

                />
                <CommonButton
                    title="Apply Filters"
                    variant="primary"
                    onClick={handleApply}

                />
            </Modal.Footer>
        </>
    );
};

const MarketPlaceFilter = withModal(MarketPlaceFilterInner);

export default MarketPlaceFilter;